import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import { Button, Typography } from '@material-ui/core';

const ModalAtualizarCertificado = ({ open, close, dados }) => {

    const formataMensagem = () => {
        if (!dados) return;

        if (dados.dias_vencimento <= 0 || isNaN(dados.dias_vencimento)) {
            return `Seu certificado digital venceu. Deseja atualizá-lo?`;
        } else {
            return `Seu certificado digital vence em ${dados.dias_vencimento} dias. Deseja atualizá-lo?`;
        }
    }

    return (
        <Dialog fullWidth maxWidth={'sm'}
            open={open}
            onClose={close}
        >
            <DialogTitle>
                <div style={{
                    display: 'flex',
                    flexDirection: 'row', justifyContent: 'space-between', width: "100%", alignItems: 'center',
                    backgroundColor: '#fff'
                }}>
                    <div style={{
                        display: 'flex', width: "100%", flexDirection: "row"
                    }} >
                        <Typography>{dados.razao_social}</Typography>
                    </div>
                    <div style={{
                        display: 'flex', width: "100%", justifyContent: 'flex-end'
                    }}>
                        <IconButton
                            aria-label="close"
                            onClick={close}
                        >
                            <CloseIcon />
                        </IconButton>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent style={{ backgroundColor: '#fff', }} >
                <DialogContentText style={{ alignItems: 'center' }}>

                    {sessionStorage.getItem("@Emissor/logoHorizontal") !== 'undefined' ?
                        <img src={`data:image/png;base64,${sessionStorage.getItem("@Emissor/logoHorizontal")}`}
                            alt="Logo" title="Logo"
                            width={'50%'}
                            height={'50%'}
                            style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block', objectFit: 'cover' }} />
                        :
                        <img width={'50%'}
                            height={'50%'}
                            src={require('../../assets/images/logo.png')}
                            alt="Logo" title="Logo"
                            style={{ marginLeft: 'auto', marginRight: 'auto', display: 'block', objectFit: 'cover' }} />
                    }
                    <Typography style={{ fontWeight: 'bold', textAlign: "center", color: 'black' }}>
                        {formataMensagem()}
                    </Typography>

                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', width: "100%", alignItems: 'center' }}>
                        <Button variant='outlined'
                            onClick={() => {
                                close();
                            }}
                            style={{
                                marginTop: 15, color: "#4d79ff", borderColor: "#4d79ff", borderWidth: 2, marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                            }}>
                            Deixar para depois
                        </Button>
                        <Button variant='contained' color="primary"
                            onClick={() => {
                                window.open("https://api.whatsapp.com/send?phone=5562982609109", '_blank').focus();
                                close();
                            }}
                            style={{
                                marginTop: 15, color: "#fff", borderColor: "#4d79ff", borderWidth: 2, marginLeft: 'auto',
                                marginRight: 'auto',
                                display: 'block',
                            }}>
                            Atualizar Certificado Digital
                            <WhatsAppIcon style={{ color: "#fff", marginLeft: 5 }} size={30} />
                        </Button>
                    </div>
                </DialogContentText>
            </DialogContent>
        </Dialog >
    )



}

export default ModalAtualizarCertificado;
